import * as z from "zod/v4";

export enum RoutingRuleType {
  PRIORITY_ORDER = "priorityOrder",
  INVENTORY_AVAILABLE = "inventoryAvailable",
  CLOSEST_PROXIMITY = "closestProximity",
}

export const PriorityOrderConfigSchema = z.object({
  type: z.literal(RoutingRuleType.PRIORITY_ORDER),
  config: z.object({ locationIds: z.array(z.string()) }),
});

export const InventoryAvailableConfigSchema = z.object({
  type: z.literal(RoutingRuleType.INVENTORY_AVAILABLE),
  config: z.object({}).nullish().default({}),
});

export const ClosestProximityConfigSchema = z.object({
  type: z.literal(RoutingRuleType.CLOSEST_PROXIMITY),
  config: z.object({}).nullish().default({}),
});

export const RoutingRuleConfigSchema = z.discriminatedUnion("type", [
  PriorityOrderConfigSchema,
  InventoryAvailableConfigSchema,
  ClosestProximityConfigSchema,
]);

export type RoutingRuleConfig = z.infer<typeof RoutingRuleConfigSchema>;

export const ROUTING_RULE_METADATA: Record<
  RoutingRuleType,
  { label: string; description: string }
> = {
  [RoutingRuleType.PRIORITY_ORDER]: {
    label: "Priority Order",
    description:
      "Route orders to locations in a specific priority order. The first location in the list is tried first.",
  },
  [RoutingRuleType.INVENTORY_AVAILABLE]: {
    label: "Inventory Available",
    description:
      "Only route to a location if it has sufficient inventory for all items in the order.",
  },
  [RoutingRuleType.CLOSEST_PROXIMITY]: {
    label: "Closest Proximity",
    description:
      "Rank locations by distance to the shipping destination. Closest location is tried first.",
  },
};
